export default __webpack_public_path__ + "static/media/g15.904bd97c.png";